import { Trash } from "@phosphor-icons/react";
import { PageTitle } from "../../../components/PageTitle";
import { Action, Header, Table } from "../../../components/Table";
import { UserRole } from "../../../models/User";
import { TopView } from "./styles";
import { Log } from "../../../models/Log";
import { useLogController } from "../../../controllers/logController";
import { format } from "date-fns";

const headers: Array<Header<Log>> = [
  {
    label: "Mensagem",
    key: "description",
    roles: [ UserRole.ADMIN, UserRole.MANAGER ]
  },
  {
    label: "Usuário",
    key: "userSession",
    nested: ( row ) => row.userSession?.name ?? '-',
    roles: [ UserRole.ADMIN, UserRole.MANAGER ],
    align: "center",
    maxPossibleWidth: false,
  },
  {
    label: "Data/Hora",
    key: "createdAt",
    transform: ( value ) => format( new Date( value ), "dd/MM/yy HH:mm"),
    roles: [ UserRole.ADMIN, UserRole.MANAGER ],
    align: "center",
    maxPossibleWidth: false,
  },
];

export const Logs = () => {
  const {
    page,
    perPage,
    total,
    logs,
    loadingLogs,
    changePage,
    handleDelete,
  } = useLogController();

  const actions: Array<Action<Log>> = [
    {
      icon: Trash,
      label: "Excluir",
      color: "error",
      onClick: ({ id }) => handleDelete( id ),
    },
  ];

  return (
    <>
      <TopView>
        <PageTitle>Registro de Logs</PageTitle>
      </TopView>

      <Table<Log>
        keyProperty="id"
        changePage={ changePage }
        page={ page }
        perPage={ perPage }
        total={ total }
        loading={ loadingLogs }
        data={ logs }
        headers={ headers }
        actions={ actions }
      />
    </>
  );
};
